import * as React from "react";
import { DateHelper } from "../../../../../../react-core/Helpers/DateHelper";
import { formatMoney } from "../../../../../../react-core/Utils/Money";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { SubAccountTypeArrayMap } from "../../../../../Admin/Company/CompanyWizard/Resource/Content";
import { subAccountTypeMap } from "../../../Clients/PortfolioDashboard/Components/Performance/Resource/Contents";

export interface IAssetHoldingsTableRow {
    subAccountType: SubAccountType;
    startValue: number;
    endValue: number;
}

interface IAssetHoldingsTableProps {
    asAtStart: Date;
    asAtEnd: Date;
    rows: IAssetHoldingsTableRow[];
}

const AssetHoldingsTable = (props: IAssetHoldingsTableProps) => {
    return (
        <table className="data-table">
            <thead>
                <tr>
                    <th>Product</th>
                    <th className="cell-right">
                        Asset holdings as at {DateHelper.getDateStringAsddmmmyyyy(props.asAtStart)}
                    </th>
                    <th className="cell-right">
                        Asset holdings as at {DateHelper.getDateStringAsddmmmyyyy(props.asAtEnd)}
                    </th>
                    <th className="cell-right">Difference</th>
                </tr>
            </thead>

            <tbody>
                {props.rows.map((row) => {
                    return (
                        <tr
                            className={`product-heading ${
                                SubAccountTypeArrayMap.colorClassNameMap[row.subAccountType]
                            }`}
                        >
                            <td>
                                <span
                                    className={`product-legend ${
                                        SubAccountTypeArrayMap.colorClassNameMap[row.subAccountType]
                                    }`}
                                />
                                <span
                                    className={`${SubAccountTypeArrayMap.colorClassNameMap[row.subAccountType]}-text`}
                                >
                                    {subAccountTypeMap[row.subAccountType]}
                                </span>
                            </td>
                            <td className="cell-right">
                                £{formatMoney({ Currency: CurrencyCode.GBP, Amount: row.startValue }, true, 2)}
                            </td>
                            <td className="cell-right">
                                £{formatMoney({ Currency: CurrencyCode.GBP, Amount: row.endValue }, true, 2)}
                            </td>
                            <td
                                className={`cell-right ${
                                    calculateDifference(row) < 0 ? "text-negative" : "text-positive"
                                }`}
                            >
                                £
                                {formatMoney({ Currency: CurrencyCode.GBP, Amount: calculateDifference(row) }, true, 2)}
                            </td>
                        </tr>
                    );
                })}
            </tbody>

            <tfoot>
                <tr>
                    <td>Portfolio total</td>
                    <td className="cell-right">
                        £
                        {formatMoney(
                            {
                                Currency: CurrencyCode.GBP,
                                Amount: props.rows.reduce((total, row) => (total += row.startValue || 0), 0),
                            },
                            true,
                            2
                        )}
                    </td>
                    <td className="cell-right">
                        £
                        {formatMoney(
                            {
                                Currency: CurrencyCode.GBP,
                                Amount: props.rows.reduce((total, row) => (total += row.endValue || 0), 0),
                            },
                            true,
                            2
                        )}
                    </td>
                    <td className={`cell-right ${calculateTotalDifference() < 0 ? "text-negative" : "text-positive"}`}>
                        £{formatMoney({ Currency: CurrencyCode.GBP, Amount: calculateTotalDifference() }, true, 2)}
                    </td>
                </tr>
            </tfoot>
        </table>
    );

    function calculateTotalDifference(): number {
        return props.rows.reduce((total, row) => (total += calculateDifference(row)), 0);
    }

    function calculateDifference(row: IAssetHoldingsTableRow): number {
        const difference = (row.endValue || 0) - (row.startValue || 0);
        return difference;
    }
};

export default AssetHoldingsTable;
